import { Button, Grid } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import BreadCrumbs from 'ui-component/cards/BreadCrumbs';
import TeamsList from './TeamsList';

const Teams = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClickAddProject = async () => {
    navigate('addteams');
  };
  return (
    <Grid container spacing={2}>
      <BreadCrumbs title={'New & Events'} />
      <Grid item xs={12} md={12} display={'flex'} justifyContent={'flex-end'}>
        <Button variant="contained" onClick={handleClickAddProject}>
          {' '}
          + Add New
        </Button>
      </Grid>
      <Grid item xs={12} md={12}>
        <TeamsList />
      </Grid>
    </Grid>
  );
};

export default Teams;
